import CustomSlider from '@components/CustomSlider/CustomSlider';
import styles from './SpacingContent.module.scss'
import Button from '@components/Button';
import { WheelEvent } from 'react';

export interface SpacingContentProps {
  value: number;
  onChangeValue: (val: number) => void;
  onReset: ()=>void;
  onClose: () => void;
}

const SpacingContent: React.FC<SpacingContentProps> = ({
  value,
  onChangeValue,
  onReset,
  onClose
}) => {
  return (
    <div className={styles['Container']}>
      <div className={styles['Box1']}>
        Spacing
        <Button
          className={styles.resetButton}
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
      <div className={styles['Box2']}
      onWheel={(e:WheelEvent)=>{
        if (e.deltaY === 0) return;
        const newVal = Math.min(10.0,Math.max(1.0,value+Math.sign(-e.deltaY)));
        onChangeValue(newVal);
      }}
      >
        <CustomSlider
          type="default"
          value={value}
          onChange={onChangeValue}
          min={1.0}
          max={10.0}
          step={1.0}
        />
        <div className={styles['value']}>
          {value}
        </div>
      </div>
    </div>
  )
}

export default SpacingContent;
